import { experience } from 'data/bio';
import ExperienceItem from '../ExperienceItem';
import styles from './experiencesection.module.scss';

const ExperienceSection: React.FC = () => {
  return (
    <section id="experiences-section-root" className={styles.experiencesSectionRoot}>
      <div className={styles.sectionContainer}>
        <h1>employment</h1>
        {experience.employment.map(item => (
          <ExperienceItem key={item.id} item={item} />
        ))}
        <hr />
        <h1>education</h1>
        {experience.education.map(item => (
          <ExperienceItem key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
};

export default ExperienceSection;
